var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplyingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#DDF5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20V22H38.586L30 30.586L25.707 26.293C25.5195 26.1055 25.2652 26.0002 25 26.0002C24.7348 26.0002 24.4805 26.1055 24.293 26.293L14 36.586L15.414 38L25 28.414L29.293 32.707C29.4805 32.8945 29.7348 32.9998 30 32.9998C30.2652 32.9998 30.5195 32.8945 30.707 32.707L40 23.414V30H42V20H32Z",
    fill: "#00B9DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyingIcon);
export default __webpack_public_path__ + "static/media/supplyingIcon.d5a5f5fa3fdf0e050411db95d394f8e0.svg";
export { ForwardRef as ReactComponent };